const IRREGULAR_BASES = {
  am: ['be', 'be 动词原形'], is: ['be', 'be 动词原形'], are: ['be', 'be 动词原形'],
  was: ['be', '过去式对应原形'], were: ['be', '过去式对应原形'], been: ['be', '过去分词对应原形'], being: ['be', '现在分词对应原形'],
  has: ['have', '第三人称对应原形'], had: ['have', '过去式对应原形'],
  does: ['do', '第三人称对应原形'], did: ['do', '过去式对应原形'], done: ['do', '过去分词对应原形'],
  goes: ['go', '第三人称对应原形'], went: ['go', '过去式对应原形'], gone: ['go', '过去分词对应原形'],
  came: ['come', '过去式对应原形'], come: ['come', '过去分词对应原形'],
  took: ['take', '过去式对应原形'], taken: ['take', '过去分词对应原形'],
  gave: ['give', '过去式对应原形'], given: ['give', '过去分词对应原形'],
  saw: ['see', '过去式对应原形'], seen: ['see', '过去分词对应原形'],
  wrote: ['write', '过去式对应原形'], written: ['write', '过去分词对应原形'],
  ran: ['run', '过去式对应原形'], made: ['make', '过去式对应原形'],
  said: ['say', '过去式对应原形'], thought: ['think', '过去式对应原形'],
  bought: ['buy', '过去式对应原形'], brought: ['bring', '过去式对应原形'],
  taught: ['teach', '过去式对应原形'], caught: ['catch', '过去式对应原形'],
  left: ['leave', '过去式对应原形'], felt: ['feel', '过去式对应原形'],
  kept: ['keep', '过去式对应原形'], slept: ['sleep', '过去式对应原形'],
  children: ['child', '复数对应原形'], men: ['man', '复数对应原形'], women: ['woman', '复数对应原形'],
  teeth: ['tooth', '复数对应原形'], feet: ['foot', '复数对应原形'], mice: ['mouse', '复数对应原形'],
  geese: ['goose', '复数对应原形'], people: ['person', '复数对应原形'],
  better: ['good', '比较级对应原形'], best: ['good', '最高级对应原形'],
  worse: ['bad', '比较级对应原形'], worst: ['bad', '最高级对应原形']
}

const RELATION_PRIORITY = {
  '不规则词形': 0,
  '复数': 1,
  '第三人称': 1,
  '过去式': 1,
  '过去分词': 1,
  '现在分词': 1,
  '比较级': 1,
  '最高级': 1,
  '名词派生': 2,
  '形容词派生': 2,
  '副词派生': 2,
  '动词派生': 2,
  '前缀派生': 3
}

let cachedTextbookWords = null
let cachedGaokaoWords = null
let cachedIndex = null

function normalizeWord(value) {
  return String(value || '').trim().toLowerCase()
}

function isEnglishWord(value) {
  return /^[a-z]+(?:['-][a-z]+)*$/i.test(String(value || '').trim())
}

function addCandidate(candidates, word, relation, label) {
  const normalized = normalizeWord(word)
  if (normalized.length < 2 || !/^[a-z]+$/.test(normalized)) return
  const key = `${normalized}\u0001${relation}`
  if (!candidates.some(item => item.key === key)) {
    candidates.push({ key, word: normalized, relation, label })
  }
}

function addInflectionCandidates(word, candidates) {
  const irregular = IRREGULAR_BASES[word]
  if (irregular) addCandidate(candidates, irregular[0], '不规则词形', irregular[1])

  if (word.endsWith('ies') && word.length > 4) addCandidate(candidates, `${word.slice(0, -3)}y`, '复数', '复数或第三人称')
  if (word.endsWith('es') && word.length > 4) {
    addCandidate(candidates, word.slice(0, -2), '复数', '复数或第三人称')
    addCandidate(candidates, word.slice(0, -1), '复数', '复数或第三人称')
  }
  if (word.endsWith('s') && word.length > 3 && !word.endsWith('ss')) addCandidate(candidates, word.slice(0, -1), '复数', '复数或第三人称')

  if (word.endsWith('ied') && word.length > 4) addCandidate(candidates, `${word.slice(0, -3)}y`, '过去式', '过去式')
  if (word.endsWith('ed') && word.length > 4) {
    const stem = word.slice(0, -2)
    addCandidate(candidates, stem, '过去式', '过去式或过去分词')
    addCandidate(candidates, `${stem}e`, '过去式', '过去式或过去分词')
    if (stem.length > 3 && stem[stem.length - 1] === stem[stem.length - 2]) addCandidate(candidates, stem.slice(0, -1), '过去式', '过去式或过去分词')
  }

  if (word.endsWith('ing') && word.length > 5) {
    const stem = word.slice(0, -3)
    addCandidate(candidates, stem, '现在分词', '现在分词')
    addCandidate(candidates, `${stem}e`, '现在分词', '现在分词')
    if (stem.length > 3 && stem[stem.length - 1] === stem[stem.length - 2]) addCandidate(candidates, stem.slice(0, -1), '现在分词', '现在分词')
  }

  if (word.endsWith('iest') && word.length > 5) addCandidate(candidates, `${word.slice(0, -4)}y`, '最高级', '最高级')
  if (word.endsWith('ier') && word.length > 4) addCandidate(candidates, `${word.slice(0, -3)}y`, '比较级', '比较级')
  if (word.endsWith('est') && word.length > 5) {
    const stem = word.slice(0, -3)
    addCandidate(candidates, stem, '最高级', '最高级')
    if (stem.length > 3 && stem[stem.length - 1] === stem[stem.length - 2]) addCandidate(candidates, stem.slice(0, -1), '最高级', '最高级')
  }
  if (word.endsWith('er') && word.length > 4) {
    const stem = word.slice(0, -2)
    addCandidate(candidates, stem, '比较级', '比较级')
    if (stem.length > 3 && stem[stem.length - 1] === stem[stem.length - 2]) addCandidate(candidates, stem.slice(0, -1), '比较级', '比较级')
  }
}

function addDerivationCandidates(word, candidates) {
  ;[
    ['un', '前缀派生', '否定前缀'], ['re', '前缀派生', '重复前缀'], ['dis', '前缀派生', '否定前缀'],
    ['mis', '前缀派生', '否定前缀'], ['pre', '前缀派生', '前缀派生'], ['post', '前缀派生', '前缀派生'],
    ['over', '前缀派生', '前缀派生'], ['under', '前缀派生', '前缀派生'], ['non', '前缀派生', '否定前缀'],
    ['im', '前缀派生', '否定前缀'], ['in', '前缀派生', '否定前缀'], ['ir', '前缀派生', '否定前缀'], ['il', '前缀派生', '否定前缀']
  ].forEach(([prefix, relation, label]) => {
    if (word.startsWith(prefix) && word.length - prefix.length >= 3) addCandidate(candidates, word.slice(prefix.length), relation, label)
  })

  const suffixes = [
    ['iness', 'y', '名词派生', '名词派生'], ['ness', '', '名词派生', '名词派生'], ['ment', '', '名词派生', '名词派生'],
    ['ation', '', '名词派生', '名词派生'], ['ion', '', '名词派生', '名词派生'], ['sion', 'de', '名词派生', '名词派生'],
    ['ity', 'e', '名词派生', '名词派生'], ['ity', '', '名词派生', '名词派生'], ['al', '', '名词派生', '名词派生'],
    ['ive', '', '形容词派生', '形容词派生'], ['ous', '', '形容词派生', '形容词派生'], ['ful', '', '形容词派生', '形容词派生'],
    ['less', '', '形容词派生', '形容词派生'], ['able', '', '形容词派生', '形容词派生'], ['ible', '', '形容词派生', '形容词派生'],
    ['ly', '', '副词派生', '副词派生'], ['ize', '', '动词派生', '动词派生'], ['ise', '', '动词派生', '动词派生'],
    ['ify', '', '动词派生', '动词派生'], ['en', '', '动词派生', '动词派生'], ['or', '', '名词派生', '名词派生']
  ]
  suffixes.forEach(([suffix, replacement, relation, label]) => {
    if (word.endsWith(suffix) && word.length - suffix.length >= 3) {
      addCandidate(candidates, `${word.slice(0, -suffix.length)}${replacement}`, relation, label)
    }
  })
}

function getBaseCandidates(word) {
  const candidates = []
  addInflectionCandidates(word, candidates)
  addDerivationCandidates(word, candidates)
  return candidates
}

function getWordFamilyIndex(textbookWords, gaokaoWords) {
  if (cachedIndex && cachedTextbookWords === textbookWords && cachedGaokaoWords === gaokaoWords) return cachedIndex

  const exact = new Map()
  const append = (item, source) => {
    const word = normalizeWord(item && item.英文)
    if (!word || !isEnglishWord(word)) return
    let entry = exact.get(word)
    if (!entry) {
      entry = { word, textbooks: [], gaokao: null }
      exact.set(word, entry)
    }
    if (source === 'textbook') entry.textbooks.push(item)
    else if (!entry.gaokao) entry.gaokao = item
  }
  ;(Array.isArray(textbookWords) ? textbookWords : []).forEach(item => append(item, 'textbook'))
  ;(Array.isArray(gaokaoWords) ? gaokaoWords : []).forEach(item => append(item, 'gaokao'))

  const derivedByBase = new Map()
  exact.forEach(entry => {
    getBaseCandidates(entry.word).forEach(candidate => {
      const matches = derivedByBase.get(candidate.word) || []
      matches.push({ entry, relation: candidate.relation, label: candidate.label })
      derivedByBase.set(candidate.word, matches)
    })
  })

  cachedTextbookWords = textbookWords
  cachedGaokaoWords = gaokaoWords
  cachedIndex = { exact, derivedByBase }
  return cachedIndex
}

function relationLabel(match, direction) {
  if (direction === 'reverse') return `原形（${match.label}）`
  return match.label
}

function makeDisplayResult(match) {
  const { entry, relation, label, direction } = match
  const textbookLines = entry.textbooks.map(item => `${item.教材 || ''} ${item.模块 || ''}`.trim()).filter(Boolean)
  const textbookDetail = entry.textbooks.map(item => {
    return `${item.教材 || '教材词库'} ${item.模块 || ''}\n${item.词性 || ''}\n${item.中文 || ''}`.trim()
  })
  const gaokaoDetail = entry.gaokao
    ? [
      `2027年高考3500释义：\n${entry.gaokao.中文 || ''}`
    ].join('\n-------------------------------\n')
    : ''
  const translation = String((entry.gaokao && entry.gaokao.中文) || (entry.textbooks[0] && entry.textbooks[0].中文) || '')
  const attributes = Array.from(new Set([
    entry.gaokao && entry.gaokao.词性,
    ...entry.textbooks.map(item => item.词性)
  ].filter(Boolean))).join(' / ')
  const details = [...textbookDetail, gaokaoDetail].filter(Boolean)

  return {
    英文: entry.word,
    中文: translation,
    简单中文: translation.slice(0, 50),
    词性: attributes,
    教材: textbookLines.join('；'),
    模块: '',
    单元: textbookLines.join('；'),
    备注: '',
    弹窗中文: details.join('\n-------------------------------\n'),
    关系标签: relation ? relationLabel({ label }, direction) : '',
    关系优先级: relation ? (RELATION_PRIORITY[relation] ?? 9) : -1
  }
}

function queryWordFamily(query, textbookWords, gaokaoWords) {
  const normalized = normalizeWord(query)
  if (!isEnglishWord(normalized)) return { mode: 'invalid', query: normalized, results: [] }

  const index = getWordFamilyIndex(textbookWords, gaokaoWords)
  const exact = index.exact.get(normalized)
  if (exact) {
    return { mode: 'exact', query: normalized, results: [makeDisplayResult({ entry: exact })] }
  }

  const matches = new Map()
  const append = match => {
    const current = matches.get(match.entry.word)
    if (!current || (RELATION_PRIORITY[match.relation] ?? 9) < (RELATION_PRIORITY[current.relation] ?? 9)) matches.set(match.entry.word, match)
  }
  ;(index.derivedByBase.get(normalized) || []).forEach(match => append({ ...match, direction: 'forward' }))
  getBaseCandidates(normalized).forEach(candidate => {
    const entry = index.exact.get(candidate.word)
    if (entry) append({ entry, relation: candidate.relation, label: candidate.label, direction: 'reverse' })
  })

  const results = Array.from(matches.values())
    .sort((left, right) => {
      const priority = (RELATION_PRIORITY[left.relation] ?? 9) - (RELATION_PRIORITY[right.relation] ?? 9)
      return priority || left.entry.word.length - right.entry.word.length || left.entry.word.localeCompare(right.entry.word)
    })
    .map(makeDisplayResult)
  return { mode: results.length ? 'derivative' : 'none', query: normalized, results }
}

module.exports = { isEnglishWord, normalizeWord, queryWordFamily }
